<template>
  <div class="node-panel">
    <div class="node-item"
      v-for="item in nodeList"
      :key="item.text"
      @mousedown="$_dragNode(item)">
    <div class="node-item-icon" :class="item.class">
      <div v-if="item.type === 'user' || item.type === 'time'" class="shape"></div>
    </div>
    <span class="node-label">{{item.text}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NodePanel',
  props: {
    lf: Object,
    nodeList: Array,

  },
  methods: {
    $_dragNode (item) {
      this.$props.lf.dnd.startDrag({
        type: item.type,
      })
      this.$emit('addNodeFinish',item)
    }
  }
}
</script>
<style>
.node-panel {
  position: absolute;
  top: 25px;
  left: 5px;
  width: 40px;
  padding: 20px 10px;
  background-color: white;
  box-shadow: 0 0 10px 1px rgb(228, 224, 219);
  border-radius: 6px;
  text-align: center;
  z-index: 101;
}
.node-item {
  margin-bottom: 20px;
}
.node-item-icon {
  width: 30px;
  height: 30px;
  margin-left: 5px;
  background-size: cover;
}
.node-label {
  font-size: 12px;
  margin-top: 25px;
  user-select: none;
}
.node-start{
  background: url('../background/start.svg') no-repeat;
  background-size: cover;
}
.node-rect{
  border: 2px solid #479a5c;
}

.node-end{
  /*background: url('../background/end.png') no-repeat;*/
  background: url('../background/end.svg') no-repeat;
  background-size: cover;
}
.node-subflow{
  /*background: url('../background/end.png') no-repeat;*/
  background: url('../background/subflow.svg') no-repeat;
  background-size: cover;
}

.node-approval{

  background: url('../background/approval.svg') no-repeat;
  background-size: cover;
}
.node-task
{

  background: url('../background/task.svg') no-repeat;
  background-size: cover;

}
.node-wait{

  background: url('../background/wait.svg') no-repeat;
  background-size: cover;
}
.node-jugement
{

  width: 26px;
  height: 26px;
  border: 2px solid #6495ED;
  transform:rotate(45deg);
}

</style>
